import React from 'react'
import {Button, Header, Modal} from "semantic-ui-react";
import {socket} from "../../lib/socketio";
import {useSelector} from "react-redux";
import {createUserLog} from "../../lib/api";

const ActivateOverride =({ovrdata, tags, settags, option, channel,title, parentCallback,settempovrdata,tempoverridden, settempoverriden}) => {

    const [toggle, setToggle] = React.useState();
    const [open,setOpen]= React.useState(false);
    const ppid = useSelector(state => state.header.ppid);
    const user = useSelector(state => state.nav.user);
    const electronApp = useSelector(state => state.nav.electronApp);

    const handleOpen = () => setOpen( true);
    const handleClose = () => setOpen( false);

    const handleToggle =(event, {id}) => {
        setToggle(id);
        event.preventDefault();
        console.log(ovrdata);
        if(id === '1') { // btn OK click 
            // @ TEST SOFC 240524, add condition
            if(Object.values(ovrdata).length > 0){ 
                console.log('length > 0 ')
                var adiodata = {'buttonClickType': channel, 'tags': ovrdata};
                socket.emit('button click', adiodata);

                if (!electronApp) {
                    let log = {
                        user_id: user.id,
                        powerplant_id: ppid,
                        display_id: null,
                        datetime: new Date().toISOString(),
                        data: JSON.stringify({ tags: adiodata.tags, type: channel }),
                    };
                    createUserLog({ log }).catch(console.error);
                }
            }
            
            setOpen(false);
            parentCallback(true);
            settags([...tags]);
            settempovrdata({});
            settempoverriden({...tempoverridden, [id]: 1});
        }
        else if(id === '2'){
            setOpen(false);
        }
    }

    return (
        <div>
            {option === 2 ?
                <Modal trigger = {<Button color = 'blue'>{title} </Button>}
                   style = {styles.toggle}
                   open = {open}
                   onClose={handleClose}
                   onOpen={handleOpen}>
                    <Modal.Header>Confirmation</Modal.Header>
                    <Modal.Description>
                        <Header style = {styles.header}> Do you want to {channel}?</Header>
                    </Modal.Description>
                    <Modal.Actions>
                        <Button color={'green'}
                                size='small'
                                id = '1'
                                active={toggle==='1'}
                                content='OK'
                                onClick={handleToggle}
                        />
                        <Button color={'red'}
                                size='small'
                                id = '2'
                                active={toggle==='2'}
                                content='Cancel'
                                onClick={handleToggle}
                        />
                    </Modal.Actions>
                </Modal>
                : option === 4 ? // option 4 : Start Burner flow control overrides
                    <Modal 
                        trigger = {<Button color = 'blue'>ACTIVATE OVERRIDES </Button>}
                        style = {styles.toggle}
                        open = {open}
                        onClose={handleClose}
                        onOpen={handleOpen}>
                        <Modal.Header>Confirmation</Modal.Header>
                        <Modal.Description>
                            <Header style = {styles.header}> Do you want to {channel}?</Header>
                        </Modal.Description>
                        <Modal.Actions>
                            <Button color={'green'}
                                size='small'
                                id = '1'
                                active={toggle==='1'}
                                content='OK'
                                onClick={handleToggle}
                            />
                            <Button 
                                color={'red'}
                                size='small'
                                id = '2'
                                active={toggle==='2'}
                                content='Cancel'
                                onClick={handleToggle}
                            />
                        </Modal.Actions>
                    </Modal>
                : // analog override - activate all overrides
                    <Modal 
                        trigger = {<Button color = 'blue'>ACTIVATE ALL OVERRIDES </Button>}
                        style = {styles.toggle}
                        open = {open}
                        onClose={handleClose}
                        onOpen={handleOpen}>
                        <Modal.Header>Confirmation</Modal.Header>
                        <Modal.Description>
                            <Header style = {styles.header}> Do you want to {channel}?</Header>
                        </Modal.Description>
                        <Modal.Actions>
                            <Button color={'green'}
                                    size='small'
                                    id = '1'
                                    active={toggle==='1'}
                                    content='OK'
                                    onClick={handleToggle}
                            />
                            <Button color={'red'}
                                    size='small'
                                    id = '2'
                                    active={toggle==='2'}
                                    content='Cancel'
                                    onClick={handleToggle}
                            />
                        </Modal.Actions>
                    </Modal>
                }
        </div>
    );
}

const styles = {
    input: {
        padding: '15px'
    },
    toggle: {
        maxWidth: '400px',
        marginTop: '5px',
        marginBottom: '25px',
        alignItems: 'center'
    },
    header: {
        marginTop: '15px',
        marginLeft: '15px'
    }
}

export default ActivateOverride;